import { render, staticRenderFns } from "./TranProgramUpdate.vue?vue&type=template&id=ede67ba0&scoped=true"
import script from "./TranProgramUpdate.vue?vue&type=script&lang=js"
export * from "./TranProgramUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranProgramUpdate.vue?vue&type=style&index=0&id=ede67ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede67ba0",
  null
  
)

export default component.exports